import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h1>Privacy Policy</h1>
            <p>Your privacy is important to us. This privacy policy explains how we handle your personal information.</p>
            <h2>Information We Collect</h2>
            <p>We collect information to provide better services to our users.</p>
            <h2>How We Use Information</h2>
            <p>We use the information we collect to maintain and improve our services.</p>
            <h2>Information Sharing</h2>
            <p>We do not share personal information with companies, organizations, or individuals outside of our company.</p>
            <h2>Contact Us</h2>
            <p>If you have any questions about this privacy policy, please contact us.</p>
        </div>
    );
};

export default PrivacyPolicy;